"use client";

import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import {
  Paintbrush,
  Palette,
  Sparkles,
  Shirt,
  Eraser,
  Scissors,
} from "lucide-react";

const services = [
  {
    icon: Paintbrush,
    title: "Photo Retouching",
    description: "Skin retouching and beauty enhancement",
    price: "From $15",
    features: ["Skin smoothing", "Blemish removal", "Teeth whitening"],
    popular: false,
  },
  {
    icon: Eraser,
    title: "Background Removal",
    description: "Clean background removal and replacement",
    price: "From $5",
    features: ["White background", "Transparent PNG", "Custom backgrounds"],
    popular: true,
  },
  {
    icon: Palette,
    title: "Color Correction",
    description: "Expert color grading and correction",
    price: "From $10",
    features: ["Color balance", "Exposure fix", "Saturation"],
    popular: false,
  },
  {
    icon: Scissors,
    title: "Clipping Path",
    description: "Precise clipping paths for clean cutouts",
    price: "From $3",
    features: ["Simple paths", "Complex shapes", "Multi-path"],
    popular: false,
  },
  {
    icon: Shirt,
    title: "Ghost Mannequin",
    description: "Invisible mannequin effect for clothing",
    price: "From $20",
    features: ["Neck joint", "Sleeve attachment", "3D effect"],
    popular: false,
  },
  {
    icon: Sparkles,
    title: "Shadow Creation",
    description: "Natural shadow and reflection effects",
    price: "From $8",
    features: ["Drop shadows", "Natural shadows", "Reflections"],
    popular: false,
  },
];

export function Services() {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Our Professional Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From basic edits to complex transformations, we offer comprehensive
            photo editing solutions with transparent pricing and fast turnaround
            times.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card
                className={`h-full hover:shadow-xl transition-all duration-300 group relative`}
              >
                {/* {service.popular && (
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                    <span className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-1 rounded-full text-sm font-semibold">
                      Most Popular
                    </span>
                  </div>
                )} */}
                <CardContent className="px-6 flex flex-col">
                  <div className="mb-3 flex space-x-3">
                    <div className="w-12 h-12 shrink-0 bg-primary/10 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                      <service.icon className="w-6 h-6 text-primary" />
                    </div>
                    <div className="flex flex-col items-start justify-between mb-3">
                      <h3 className="text-xl font-bold text-gray-900">
                        {service.title}
                      </h3>
                      <p className="text-gray-600">{service.description}</p>
                    </div>
                  </div>

                  <ul className="space-y-2 mb-6">
                    {service.features.map((feature, idx) => (
                      <li
                        key={idx}
                        className="flex items-center text-sm text-gray-600"
                      >
                        <div className="w-1.5 h-1.5 bg-purple-500 rounded-full mr-3" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
